import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-[#FDFBF7] px-5">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="hard-shadow-lg max-w-lg rounded-2xl border-2 border-[#0A0A0A] bg-white p-10 text-center"
      >
        <XCircle className="mx-auto h-12 w-12 text-[#FF2A54]" />
        <h1 className="mt-6 font-display text-3xl font-extrabold uppercase tracking-tight">No worries</h1>
        <p className="mt-3 text-[#4A4A4A]">
          Your checkout was cancelled — nothing was charged. The candy will be waiting when you&rsquo;re ready.
        </p>
        <Link
          to="/#shop"
          data-testid="cancel-back-to-shop-link"
          className="hard-shadow hard-shadow-hover mt-8 inline-block rounded-full border-2 border-[#0A0A0A] bg-[#FF2A54] px-8 py-3 font-display text-sm font-extrabold uppercase text-white"
        >
          Back to the goods
        </Link>
      </motion.div>
    </main>
  );
}
